<script lang="ts">
  export let image = ''
  export let alt = ''
  export let quote = ''
  export let name = ''
  export let designation = ''
  export let rating = 5
  export let variant: 'default' | 'minimal' = 'default'
</script>

{#if variant === 'default'}
  <div
    class="flex flex-col-reverse md:flex-row gap-2 md:gap-10 gap-16 items-center max-w-6xl rounded-3xl border border-am-white-60 p-4 overflow-hidden md:h-full w-fit md:max-h-[420px]"
  >
    <!-- Image -->
    <div
      class="relative w-10 h-10 md:h-full md:w-auto rounded-full md:rounded-2xl border border-am-white-60 overflow-hidden"
    >
      <img src={image} {alt} class="w-full h-full object-cover" />
    </div>

    <!-- Quote -->
    <div class="flex flex-col justify-between h-full px-2 md:pr-10 lg:py-6 gap-6">
      <blockquote
        class="text-2xl md:text-2xl !font-semibold italic text-am-black-75 max-w-[500px] text-center md:text-left"
      >
        "{quote}"
      </blockquote>

      <div class="flex flex-col md:flex-row md:w-full md:justify-between items-center gap-2">
        <!-- Star Rating -->
        {#if rating >= 1}
          <div class="flex gap-1">
            {#each Array(rating) as _, i}
              <span
                class="material-symbols-rounded text-[#536aff]"
                style="font-size: 20px; font-variation-settings: 'FILL' 1, 'wght' 300;">star</span
              >
            {/each}
          </div>
        {/if}

        <!-- Name and Designation -->
        <div class="flex flex-col items-center md:items-start">
          <p class="euphoria-script text-2xl">{name}</p>
          <p class="text-am-black-75 !font-medium">{designation}</p>
        </div>
      </div>
    </div>
  </div>
{:else}
  <div
    class="flex flex-col-reverse gap-2 items-center max-w-6xl rounded-3xl border border-am-white-60 p-4 overflow-hidden w-fit"
  >
    <!-- Quote -->
    <div class="flex flex-col justify-center md:justify-between h-full px-2 md:pr-10 lg:py-6 gap-6">
      <blockquote class="text-2xl md:text-2xl !font-semibold italic text-am-black-75 max-w-sm text-center mb-auto">
        "{quote}"
      </blockquote>

      <div class="flex justify-center items-center gap-3">
        <!-- Image -->
        <div class="relative w-14 h-14 rounded-full border border-am-white-60 overflow-hidden">
          <img src={image} {alt} class="w-full h-full object-cover" />
        </div>

        <div class="flex flex-col items-center gap-2">
          <!-- Star Rating -->
          {#if rating >= 1}
            <div class="flex gap-1">
              {#each Array(rating) as _, i}
                <span
                  class="material-symbols-rounded text-[#536aff]"
                  style="font-size: 20px; font-variation-settings: 'FILL' 1, 'wght' 300;">star</span
                >
              {/each}
            </div>
          {/if}

          <!-- Name and Designation -->
          <div class="flex flex-col">
            <p class="text-xl !font-semibold text-am-black">{name}</p>
            <p class="text-am-black-45 !font-medium max-w-[200px]">{designation}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
{/if}

<style>
  @font-face {
    font-family: 'Euphoria Script';
    src: url('/fonts/EuphoriaScript-Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  .euphoria-script {
    font-family: 'Euphoria Script', cursive;
  }
</style>
